import { createSelector } from '@reduxjs/toolkit';
import selectWishlistPageActions from '@spa/lib/store/wishlists/selectors/selectWishlistPageActions';

const selectSucceededAddProductToMyWishlistActionIds = createSelector(
  [selectWishlistPageActions],
  (wishlistsPageActions): ReadonlyArray<number> =>
    wishlistsPageActions.addProductToMyWishlist.succeeded.map(
      (action): number => action.requestedActionId
    )
);

export default selectSucceededAddProductToMyWishlistActionIds;
